import { z } from "zod";

export const TTranslationLangSchema = z.object({
  default: z.string().nullish(),
  singular: z.string().nullish(),
  plural: z.string().nullish(),
});

export type ITranslationData = z.infer<typeof TTranslationData>;
export const TTranslationData = z.record(TTranslationLangSchema);
